<template>
    <cs-app>
      <template v-slot:content>
        <div v-if="claims.length > 0">
            <md-radio v-model="radio" :value="filters.all" @change="filterClaims">All Cases</md-radio>
            <md-radio v-model="radio" :value="filters.placedBids" @change="filterClaims">Placed Bids</md-radio>
            <md-radio v-model="radio" :value="filters.acceptedBids" @change="filterClaims">Accepted Bids</md-radio>
            <md-card v-for="claim in filteredClaims" :key="claim.id" class="md-card">
                <md-card-area md-inset>
                    <md-card-header>
                        <div class="subheading-container">
                            <div class="md-subheading">{{ claim.form.title }}</div>
                            <div class="md-subheading">{{ bidState(claim) }}</div>
                        </div>
                        <div class="md-subhead" style="display: flex; justify-content: space-between; margin-top: 8px;">
                            <div>
                                <md-icon>location_on</md-icon>
                                <span>20 Km</span>
                            </div>
                            <div>
                                <md-icon>calendar_today</md-icon>
                                <span style="padding-left: 5px;">
                                    {{ $moment(claim.createdAt).format('MM/DD/YYYY') }}
                                </span>
                            </div>
                        </div>
                    </md-card-header>
                </md-card-area>

                <md-card-content>
                    <div class="card-content">
                        <div class="card-content-left">Damages:</div>
                        <div class="card-content-right">{{ getDamages(claim) }}</div>
                    </div>
                    <div class="card-content">
                        <div class="card-content-left">Injuries:</div>
                        <div class="card-content-right">{{ getInjuries(claim) }}</div>
                    </div>
                    <div class="card-content">
                        <div class="card-content-left">Income:</div>
                        <div class="card-content-right">{{ getIncome(claim) }}</div>
                    </div>
                    <div class="card-content">
                        <div class="card-content-left">Edu:</div>
                        <div class="card-content-right">{{ getEdu(claim) }}</div>
                    </div>
                </md-card-content>

                <md-card-actions>
                    <router-link :to="{name: 'lawyer.cases.show', params: {id: claim.id}}">
                        <md-button class="md-primary">
                            View
                        </md-button>
                    </router-link>
                </md-card-actions>
            </md-card>
        </div>
        <div v-else class="no-bids-copy">
            <h1 class="md-display-1">Welcome to ContingentSee!</h1>
            <p class="md-body-1">As clients submit anonymous claims they will be listed here so you can view and place bids!</p>
        </div>
      </template>
    </cs-app>
</template>

<style scoped>
.no-bids-copy {
    margin: 0 auto;
    max-width: 430px;
}
</style>

<script>
import CSApp from '@/components/CSApp'
import * as responseParser from '@/services/responseParser'

const filters = {
    all: {
        label: 'all',
        fn: function (claims) {
            return claims;
        },
    },
    placedBids: {
        label: 'placedBids',
        fn (claims, bids) {
            return claims.filter(claim => bids.find(bid => claim.id === bid.caseId) !== undefined);
        }
    },
    acceptedBids: {
        label: 'acceptedBids',
        fn (claims, bids) {
            return claims.filter(claim => claim.acceptedAt !== null)
        }
    }
}

export default {
    name: 'LawyerCasesPage',
    components: {
        'cs-app': CSApp
    },
    data: () => ({
        claims: [],
        filteredClaims: [],
        bids: [],
        filters,
        radio: filters.all
    }),
    created () {
        this.$http.get(`${process.env.VUE_APP_API_URL}/cases`).then(response => {
            this.claims = response.data
            this.filteredClaims = this.claims
        }).catch(error => error)

        this.$http.get(`${process.env.VUE_APP_API_URL}/bids`).then(response => {
            this.bids = response.data
        }).catch(error => error)
    },
    methods: {
        getDamages: data => responseParser.getDamages(data),
        getInjuries: data => responseParser.getInjuries(data),
        getIncome: data => responseParser.getAnnualIncome(data),
        getEdu: data => responseParser.getEdu(data),
        filterClaims () {
            this.filteredClaims = filters[this.radio.label].fn(this.claims, this.bids);
        },
        bidState (claim) {
            if (claim.acceptedAt !== null) {
                return 'Bid Accepted'
            }
            if (this.bids.find(bid => bid.caseId === claim.id) !== undefined) {
                return 'Bid Placed'
            }

            return ''
        }
    }
}
</script>

<style lang="scss" scoped>
  .md-card {
    max-width: 500px;
    margin: 25px 0;
    .subheading-container {
        display: flex;
        justify-content: space-between;
    }
  }

  .card-content {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
  }

  .card-content-left {
      font-weight: bold;
      padding-right: 10px;
  }

  .card-content-right {
      text-overflow: ellipsis;
      /* Required for text-overflow to do anything */
      white-space: nowrap;
      overflow: hidden;
  }

</style>
